<template lang="pug">
  b-notification(v-bind:type="type" v-bind:closable="false")
    .media
      .loading-overlay.is-active(v-if="loading")
        .loading-background
        .loading-icon
      .media-left
        b-icon(size="is-large" v-bind:icon="icon")
      .media-right
        slot
          p Nenhum dado a exibir.
</template>

<script>
  export default {
    props: {
      icon: {required: true},
      type: {required: true},
      loading: {required: true}
    }
  }
</script>

<style lang="sass" scoped>
  .media-left
    align-self: center
  .loading-overlay, .loading-background, .loading-icon
    position: absolute
  .loading-icon
    top: calc(50% - 2.5em)
</style>



// WEBPACK FOOTER //
// DataNotification.vue?1e90f931